import { render, staticRenderFns } from "./ItineraryDay.vue?vue&type=template&id=2f9c8c4c&scoped=true&"
import script from "./ItineraryDay.vue?vue&type=script&lang=js&"
export * from "./ItineraryDay.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryDay.vue?vue&type=style&index=0&id=2f9c8c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9c8c4c",
  null
  
)

export default component.exports